import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/Home'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'indexPage',
        redirect: '/xuesheng/indexPage',
        meta: { title: '首页', icon: 'indexPage', noCache: true }
    },
    {
        path: '/registerPage',
        name: 'registerPage',
        // component: Home
        component: resolve => (require(['@/page/login/registerPage'], resolve))
    },
    {
        path: '/loginPage',
        name: 'loginPage',
        // component: Home
        component: resolve => (require(['@/page/login/loginPage'], resolve))
    },
    {
        path: '/perfectPage',
        name: 'perfectPage',
        // component: Home
        component: resolve => (require(['@/page/view/ perfectInfo'], resolve))
    },
    {
        path: '/xuesheng',
        component: resolve => require(['@/page/home/Home.vue'], resolve),
        meta: { title: '首页', icon: 'home', noCache: true },
        children: [
            {
                path: '/xuesheng/indexPage',
                component: resolve => require(['@/page/view/indexPage'], resolve),
                meta: { title: '首页', icon: 'indexPage', noCache: true }
            },
            {
                path: '/xuesheng/testvue',
                name: 'testvue',
                // component: Home
                component: resolve => (require(['@/page/view/testvue'], resolve))
            },
            {
                path: '/xuesheng/listPage/:code',
                name: '/xuesheng/listPage',
                component: resolve => require(['@/page/view/comInstructions'], resolve),
                meta: { title: '列表页', icon: 'listPage', noCache: true }
            },
            {
                path: '/xuesheng/answering/:code',
                name: '/xuesheng/answering',
                component: resolve => require(['@/page/view/answering'], resolve),
                meta: { title: '开始答题', icon: 'answering', noCache: true }
            },
            {
                path: '/xuesheng/viewEvaluation',
                name: '/xuesheng/viewEvaluation',
                component: resolve => require(['@/page/view/viewEvaluation'], resolve),
                meta: { title: '测评报告', icon: 'answering', noCache: true }
            },
            {
                path: '/xuesheng/detailpage',
                name: '/xuesheng/detailpage',
                component: resolve => require(['@/page/view/detailpage'], resolve),
                meta: { title: '内容页', icon: 'detailpage', noCache: true }
            },
            {
                path: '/xuesheng/employmentListPage',
                name: '/xuesheng/employmentListPage',
                component: resolve => require(['@/page/view/employmentListPage'], resolve),
                meta: { title: '就业创业指导列表', icon: 'detailpage', noCache: true }
            },
            {
                path: '/xuesheng/employmentPage',
                name: '/xuesheng/employmentPage',
                component: resolve => require(['@/page/view/employmentPage'], resolve),
                meta: { title: '就业创业指导文章资料', icon: 'detailpage', noCache: true }
            },
            {
                path: '/xuesheng/employmentVideo',
                name: '/xuesheng/employmentVideo',
                component: resolve => require(['@/page/view/employmentVideo'], resolve),
                meta: { title: '就业创业指导视频资料', icon: 'detailpage', noCache: true }
            },
            {
                path: '/xuesheng/aboutPage',
                component: resolve => require(['@/page/view/aboutPage'], resolve),
                meta: { title: '关于我们', icon: 'aboutPage', noCache: true }
            },
            {
                path: '/xuesheng/evaluation',
                name: 'evaluation',
                component: resolve => require(['@/page/view/evaluation'], resolve),
                meta: { title: '测评', icon: 'evaluation', noCache: true }
            },
            {
                path: '/xuesheng/evaluationList/:code',
                component: resolve => require(['@/page/view/evaluationList'], resolve),
                meta: { title: '测评详情', icon: 'evaluationlist', noCache: true }
            },
            {
                path: '/xuesheng/recruitPage',
                component: resolve => require(['@/page/view/recruitPage'], resolve),
                meta: { title: '招聘信息', icon: 'recruit', noCache: true }
            },
            {
                path: '/xuesheng/resultPage/:code',
                component: resolve => require(['@/page/view/resultPage'], resolve),
                meta: { title: '测评报告', icon: 'recruit', noCache: true }
            },
            {
                path: '/xuesheng/resultPageShare/:code',
                component: resolve => require(['@/page/view/resultPageShare'], resolve),
                meta: { title: '测评报告', icon: 'recruit', noCache: true }
            },
            {
                path: '/xuesheng/userpage',
                component: resolve => require(['@/page/user/userpage'], resolve),
                meta: { title: '个人中心', icon: 'userpage', noCache: true },
                children: [{
                    path: '/xuesheng/myceping',
                    component: resolve => require(['@/page/user/myceping'], resolve),
                    meta: { title: '我的测评', keepAlive: false, icon: 'recruit', noCache: true }
                },
                {
                    path: '/xuesheng/completedPage',
                    component: resolve => require(['@/page/user/completedPage'], resolve),
                    meta: { title: '已完成测评', keepAlive: false, icon: 'recruit', noCache: true }
                },
                {
                    path: '/xuesheng/incompletePage',
                    component: resolve => require(['@/page/user/incompletePage'], resolve),
                    meta: { title: '未完成', keepAlive: false, icon: 'recruit', noCache: true }
                },
                {
                    path: '/xuesheng/myAccountPage',
                    component: resolve => require(['@/page/user/myAccountPage'], resolve),
                    meta: { title: '我的账户', keepAlive: false, icon: 'recruit', noCache: true }
                },
                {
                    path: '/xuesheng/kaichuang',
                    component: resolve => require(['@/page/user/kaichuang'], resolve),
                    meta: { title: '启创币', keepAlive: false, icon: 'recruit', noCache: true }
                },
                {
                    path: '/xuesheng/myClassPage',
                    component: resolve => require(['@/page/user/myClassPage'], resolve),
                    meta: { title: '我的班级', keepAlive: false, icon: 'recruit', noCache: true }
                }

                ]
            }
        ]
    },
    {
        path: '/laoshi',
        component: resolve => require(['@/page/home/Home.vue'], resolve),
        meta: { title: '首页', icon: 'home', noCache: true },
        children: [{
            path: '/laoshi/aboutPage',
            component: resolve => require(['@/page/view/aboutPage'], resolve),
            meta: { title: '关于我们', icon: 'aboutPage', noCache: true }
        },
        {
            path: '/laoshi/recruitPage',
            component: resolve => require(['@/page/view/recruitPage'], resolve),
            meta: { title: '招聘信息', icon: 'recruit', noCache: true }
        },
        {
            path: '/laoshi/resultPage',
            component: resolve => require(['@/page/view/resultPage'], resolve),
            meta: { title: '测评报告', icon: 'recruit', noCache: true }
        },
        {
            path: '/laoshi/userpage',
            component: resolve => require(['@/page/user/userpage'], resolve),
            meta: { title: '个人中心', icon: 'userpage', noCache: true },
            children: [{
                path: '/laoshi/myAccountPage',
                component: resolve => require(['@/page/user/myAccountPage'], resolve),
                meta: { title: '我的账户', keepAlive: false, icon: 'recruit', noCache: true }
            },
            {
                path: '/laoshi/myMenageClass',
                component: resolve => require(['@/page/teacher/myMenageClass'], resolve),
                meta: { title: '管理班级', keepAlive: false, icon: 'recruit', noCache: true }
            },
            {
                path: '/laoshi/studentManagement',
                component: resolve => require(['@/page/teacher/studentManagement.vue'], resolve),
                meta: { title: '学生管理', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/newClass',
                component: resolve => require(['@/page/teacher/newClass.vue'], resolve),
                meta: { title: '新建班级', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/editMyClass',
                component: resolve => require(['@/page/teacher/editMyClass.vue'], resolve),
                meta: { title: '修改编辑', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/evaluationManagement',
                component: resolve => require(['@/page/teacher/evaluationManagement.vue'], resolve),
                meta: { title: '测评管理', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/classList',
                component: resolve => require(['@/page/teacher/classList.vue'], resolve),
                meta: { title: '测评下的班级列表', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/classEvaluation',
                component: resolve => require(['@/page/teacher/classEvaluation.vue'], resolve),
                meta: { title: '测评下的班级列表xiayiji', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/auditList',
                component: resolve => require(['@/page/teacher/auditList.vue'], resolve),
                meta: { title: '审核列表', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/auditRecord',
                component: resolve => require(['@/page/teacher/auditRecord.vue'], resolve),
                meta: { title: '审核记录', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/statistics',
                component: resolve => require(['@/page/teacher/statistics.vue'], resolve),
                meta: { title: '测评统计', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/studentStatistics',
                component: resolve => require(['@/page/teacher/studentStatistics.vue'], resolve),
                meta: { title: '学生统计', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/studentClass',
                component: resolve => require(['@/page/teacher/studentClass.vue'], resolve),
                meta: { title: '班级下的学生列表', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/studentList',
                component: resolve => require(['@/page/teacher/studentList.vue'], resolve),
                meta: { title: '学生下已完成的测评', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/finashStudentList',
                component: resolve => require(['@/page/teacher/finashStudentList.vue'], resolve),
                meta: { title: '学生下未完成的测评', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/alreadyList',
                component: resolve => require(['@/page/teacher/alreadyList.vue'], resolve),
                meta: { title: '测评下已完成学生列表', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/unAlreadyList',
                component: resolve => require(['@/page/teacher/unAlreadyList.vue'], resolve),
                meta: { title: '测评下未完成学生列表', icon: 'home', noCache: true },
            },
            {
                path: '/laoshi/studentReport',
                component: resolve => require(['@/page/teacher/studentReport.vue'], resolve),
                meta: { title: '查看学生测评', icon: 'home', noCache: true },
            },
            ]
        }
        ]
    }
    ],
    scrollBehavior(to, form, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js